import throttle from 'lodash.throttle'
export default throttle




// WEBPACK FOOTER //
// ./~/vux/src/tools/throttle/index.js